// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__10pHa","dragIcon":"SortableItem_dragIcon__2pAWr","disabled":"SortableItem_disabled__B6G7F"};